// params:
//   - event
//   - parentPath
//   - parentOldValue
//   - parentNewValue
//   - ownOldValue
//   - side_players

const runsCreatedThisHit = (event) => {
  const kls = event.karkilyonnit
  let min = 0
  if(!event.base_changes.third_to_home && kls < 2) return 0
  if(event.base_changes.third_to_home === "O" && event.bases.third.id) min = 1

  if(!event) throw new Error('Invalid event');

  const base_items = ["third", "second", "first", "home"];
  let runs = 0
  for(let i = 0; i < kls; i++) {
    if(event.bases[base_items[i]].id) runs++
  }

  return Math.max(runs, min)
}

const findRunnerId = (e) => {
  let runner_id = null;
  const hitter_base_items = ['home', 'first', 'second', 'third']

  hitter_base_items.forEach(b => {
    if(e.bases[b]['id']) {
      runner_id = e.bases[b]['id']
    }
  })

  return runner_id
}

const karkilyonnit = e => {
  let base_index = null
  const bases = ['home', 'first', 'second', 'third']
  const base_transitions = ['home_to_first', 'first_to_second', 'second_to_third', 'third_to_home']
  bases.forEach(b => {
    if(e.bases[b].id) base_index = bases.indexOf(b)
  })

  if(e.base_changes[base_transitions[base_index]] === "O") return 1
  return 0
}

const hitterSide = (event, pp, pov, pnv, oov, players) => {
  if(pp !== 'hitter_id') return
  const player = players.find(p => p.id === pnv)
  if(!player) return null
  if(player.hits_from_left === null) return null
  return player.hits_from_left ? 'L' : 'R'
}

const basesState = e => {
  const bases = e.bases
  // "0" - "1" - "1-2" - "1-3" - "0-3" - "0-2" - "2-3" - "Ajo"
  const h = !!bases.home.id
  const f = !!bases.first.id
  const s = !!bases.second.id
  const t = !!bases.third.id

  if(!h && !f && !s && !t) return null
  if(f && s && t) return "Ajo"
  if(!f && s && t) return "2-3"
  if(f && !s && t) return "1-3"
  if(!f && !s && t) return "0-3"
  if(!f && s && !t) return "0-2"
  if(f && s && !t) return "1-2"
  if(f && !s && !t) return "1"
  if(!f && !s && !t) return "0"
}

function hitOutcome(state) {
  const base_items = ["third", "second", "first", "home"];
  const base_change_items = ['third_to_home', 'second_to_third', 'first_to_second', 'home_to_first'];

  if (!state) throw new Error('Invalid state');
  const { bases, base_changes } = state;
  if (!bases || !base_changes) return 'vapaa';

  let furthermost_found = false;
  let result = 'vapaa';  // Default result

  // Using for...of instead of forEach to allow for early returns
  for (let i = 0; i < base_items.length; i++) {
      const base = base_items[i];
      const change = base_changes[base_change_items[i]];
      const has_runner = !!bases[base].id;

      if (change && has_runner && furthermost_found) {
          // Someone behind the furthermost runner moved
          if (change === "X") return "takapalo";
          if (change === "H") return "haava_kt";
          return "takaeteneminen";
      }
      else if (change && has_runner && !furthermost_found) {
          // Furthermost runner moved
          if (change === "X") return "palo";
          if (change === "H") return "haava";
          return "karkilyonti";
      }

      if (has_runner) furthermost_found = true;
  }

  return result;  // Return 'vapaa' if no other conditions were met
}

const outsInflicted = (event) => {
  const base_items = ["third_to_home", "second_to_third", "first_to_second", "home_to_first"];
  // check state.base_changes for any X
  if(!event.base_changes) return null
  let outs = 0
  base_items.forEach(base => {
    if(event.base_changes[base] === "X") outs++
  })
  return Math.min(outs, 3 - event.outs)
}

const formInitialState = (state, players, new_state_base) => {
  const keys = Object.keys(state)

  let new_state = new_state_base

  keys.forEach(k => {
    // const path = k
    let val;
    if(state[k]['default']) {
      val = state[k]['default'](players)
      new_state = setInitialValue(val, k, state, new_state, players)
    }
  })

  return createNestedObject(new_state)
}

const setInitialValue = (val, path, instructions, state, players) => {
  let mod = {...state}
  mod[path] = val

  const item = instructions[path]
  if(!item || !item.parentOf) return mod


  for (let child_path in item.parentOf) {
    let child_new_val;
    if(instructions[child_path] && instructions[child_path]['default']) child_new_val = instructions[child_path]['default'](players)
    else child_new_val = item.parentOf[child_path](createNestedObject(state), path, null, val, null, players[state.hitting || 'home'])
    mod = setInitialValue(child_new_val, child_path, instructions, mod, players)
  }

  return mod
}

function markedByBaseChange(state) {
  // 1. get the furthermost base with a runner
  const base_items = ["home", "first", "second", "third"];
  let furthermost_base = null
  base_items.forEach(b => {
    if(state.bases[b].id) furthermost_base = b
  })
  if(!furthermost_base) return false

  // 2. check if the base change is marked with X, O or H
  const base_change_items = ["home_to_first", "first_to_second", "second_to_third", "third_to_home"];
  const base_change = state.base_changes[base_change_items[base_items.indexOf(furthermost_base)]]
  return ["O", "X", "H"].includes(base_change) || state.marked
}

function createNestedObject(flatObj) {
  const nested = {};

  for (const [key, value] of Object.entries(flatObj)) {
    const parts = key.split('.');
    let current = nested;

    for (let i = 0; i < parts.length - 1; i++) {
      current[parts[i]] = current[parts[i]] || {};
      current = current[parts[i]];
    }

    current[parts[parts.length - 1]] = value;
  }

  return nested;
}

module.exports = { markedByBaseChange, formInitialState, outsInflicted, hitterSide, hitOutcome, karkilyonnit, runsCreatedThisHit, findRunnerId, basesState }